import { render, staticRenderFns } from "./true-wallet-modal.vue?vue&type=template&id=2d197628&scoped=true&"
import script from "./true-wallet-modal.vue?vue&type=script&lang=js&"
export * from "./true-wallet-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d197628",
  null
  
)

export default component.exports